import { Expected } from "@/services/requests.js";

export default class Recaptcha {
   constructor(request) {
      this.moduleName = "recaptcha";
      this.prefix = "siteverify/";
      this.request = request;

      this.routes = {
         verify: {
            verify: body => {
               return this.request.POST(
                  {
                     url: this.prefix,
                     body
                  },
                  Expected.add({
                     200: "Resposta recebida"
                  })
               );
            }
         }
      };
   }
}
